import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import LanguageSwitcher from '@/components/LanguageSwitcher';

const Press = () => {
  const { i18n } = useTranslation();
  const isDe = i18n.language?.startsWith('de');

  return (
    <div className="min-h-screen bg-background px-4 py-16">
      <SEO
        title={isDe ? 'Presse & Medien' : 'Press & Media'}
        description={
          isDe
            ? 'Pressekit, Logos und Zitate zu DUMONGO.COM – dem satirischen Kunstprojekt, über das alle reden.'
            : 'Press kit, logos and quotes about DUMONGO.COM – the satirical art project everyone is talking about.'
        }
        path="/press"
      />
      <header className="fixed top-0 right-0 z-50 p-4">
        <LanguageSwitcher />
      </header>

      <article className="mx-auto max-w-3xl space-y-8">
        <h1 className="text-4xl md:text-6xl font-bold terminal-glow">
          [ PRESS ]
        </h1>

        <section className="terminal-border p-6 space-y-4">
          <h2 className="text-2xl font-bold text-primary">{isDe ? 'In einem Satz' : 'In one sentence'}</h2>
          <p className="text-muted-foreground italic">
            {isDe
              ? '„DUMONGO.COM ist die dümmste Highscore-Liste des Internets – und gleichzeitig vielleicht die ehrlichste."'
              : '"DUMONGO.COM is the dumbest highscore list on the internet — and possibly the most honest."'}
          </p>
        </section>

        <section className="terminal-border p-6 space-y-4">
          <h2 className="text-2xl font-bold text-primary">{isDe ? 'Fakten' : 'Fast Facts'}</h2>
          <ul className="space-y-2 text-muted-foreground">
            <li>• {isDe ? 'Gestartet:' : 'Launched:'} 2026</li>
            <li>• {isDe ? 'Konzept:' : 'Concept:'} {isDe ? 'Satirisches Kunstprojekt / soziales Experiment' : 'Satirical art project / social experiment'}</li>
            <li>• {isDe ? 'Sprachen:' : 'Languages:'} EN, DE</li>
            <li>• {isDe ? 'Zahlungen:' : 'Payments:'} Stripe (EUR, USD)</li>
            <li>• {isDe ? 'Mindestbetrag:' : 'Minimum:'} €0.01</li>
          </ul>
        </section>

        <section className="terminal-border p-6 space-y-4">
          <h2 className="text-2xl font-bold text-primary">{isDe ? 'Kontakt' : 'Contact'}</h2>
          <p className="text-muted-foreground">
            <a href="mailto:sb@butterweich.audio" className="hover:text-primary transition-colors">
              sb@butterweich.audio
            </a>
          </p>
        </section>

        <nav>
          <Link to="/" className="terminal-border inline-block px-6 py-3 hover:bg-primary hover:text-primary-foreground transition-colors">
            {isDe ? '← ZURÜCK' : '← BACK'}
          </Link>
        </nav>
      </article>
    </div>
  );
};

export default Press;
